module.exports = __webpack_public_path__ + "static/media/hero_desktop.daf34bf9.webp";